import src from "IMAGE";
export default { src, width: 40, height: 63, blurWidth: 0, blurHeight: 0};
